import { useAjax, useMzMutation } from "@harea/component";

export const useCountSoldMutation = () => {
    const ajax = useAjax();
    return useMzMutation(async (id: number) => {
        try {
            return await ajax.send({
                type: "POST",
                content_type: "application/json",
                url: `project/missing/${id}/countSold`,
                data: {},
            });
        } catch (err: any) {
            if (err?.response && typeof err.response === 'string') {
                try { err.response = JSON.parse(err.response); } catch { /* keep as-is */ }
            }
            throw err;
        }
    });
};